import objectFitImages from 'object-fit-images'
import SmoothScroll from 'smooth-scroll'
import accordion from './utility/accordion'
import navigation from './utility/navigation'

import Vue from 'vue'
import axios from 'axios'
import Slick from 'vue-slick'

import realtimerate from './realtimerate.vue'



/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */

// objectFitImages -------------------------------------------------

objectFitImages()


// accordion -------------------------------------------------

accordion(300, '.accordion')



// SmoothScroll -------------------------------------------------

var scroll = new SmoothScroll('a[href*="#"]', {
  speedAsDuration: false,
  easing: 'Linear',
  updateURL: true,
});


/* -------------------------------------------------------------------
  navigation
------------------------------------------------------------------- */

navigation('header-navBtn', 'header')


/* -------------------------------------------------------------------
  search form
------------------------------------------------------------------- */

navigation('menu-search__btn', 'menu-search__modal')
navigation('menu-search__modal__btn', 'menu-search__modal')


/* -------------------------------------------------------------------
  mainimageSlider
------------------------------------------------------------------- */

if (document.getElementById('mainimageSlider')) {
  const mainimageSlider = new Vue({
    el: "#mainimageSlider",
    components: {
      Slick,
    },
    data() {
      return {
        slickOptions: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px',
          autoplay: true,
          arrows: false,
          infinite: true,
          dots: true,
          speed: 500,
          fade: true,
        },
      }
    },
    mounted() {
    },
    methods: {
      next() {
        this.$refs.slick.next()
      },
      prev() {
        this.$refs.slick.prev()
      },
      reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
          this.$refs.slick.reSlick()
        })
      },
    },
  })
}


/* -------------------------------------------------------------------
  realTimeRate
------------------------------------------------------------------- */

if (document.getElementById('realTimeRate')) {
  const realTimeRate = new Vue({
    el: "#realTimeRate",
    components: {
      realtimerate,
    },
  })
}


/* -------------------------------------------------------------------
  realTimeRate
------------------------------------------------------------------- */

if (document.getElementById('indexRelease')) {
  const indexRelease = new Vue({
    el: "#indexRelease",
    data() {
      return {
        date:  "",
        datas: [],
        dateNextDay: "",
        datasNextDay: [],
      }
    },
    mounted() {
      this.get()
    },
    methods: {
      get() {
        // 元ファイルの取得先（旧）: https://www.okasan-online.co.jp/tradeinfo/indicator_event/economic_indicators/thismonth.html
        // 元ファイルの取得先（新）: https://www.fxshihyo.com/ or https://www.fxshihyo.com/ar/day20221207.php etc...
        axios.get(`//iwsfx.xsrv.jp/apis/data/index_release.json`)
        .then((res) => {
          this.date  = res.data[0].date
          this.datas = res.data[0].data
          this.dateNextDay  = res.data[1].date
          this.datasNextDay = res.data[1].data
        })
      },
      star(str) {
        const s_n = '<span class="icon-star-none"></span>'
        const s_1 = '<span class="icon-star"></span>'
        const s_h = '<span class="icon-star-half"></span>'
        const str_length = str.length
        switch (str_length) {
          case 1:    return `${s_1}${s_n}${s_n}`; break;
          case 2:    return `${s_1}${s_1}${s_n}`; break;
          case 3:    return `${s_1}${s_1}${s_1}`; break;
          case 4:    return `${s_1}${s_1}${s_1}${s_1}`; break;
          case 5:    return `${s_1}${s_1}${s_1}${s_1}${s_1}`; break;
          default:   return `${s_n}${s_n}${s_n}`; break;
        }
      },
      time(str) {
        if (str.length == 4) str = `0${str}`
        return str
      },
      flag(src) {
        const domain = ''
        switch (src) {
          case 'china':     return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-cny.svg`; break; // 中国
          case 'eu':        return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-eur.svg`; break; // ユーロ
          case 'turkey':    return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-try.svg`; break; // トルコ
          case 'france':    return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-fr.svg`;  break; // フランス
          case 'Germany':   return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-gm.svg`;  break; // ドイツ
          case 'uk':        return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-gbp.svg`; break; // イギリス
          case 'canada':    return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-cad.svg`; break; // カナダ
          case 'usa':       return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-usd.svg`; break; // アメリカ
          case 'australia': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-aud.svg`; break; // オーストラリア
          case 'm_afrika':  return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-zar.svg`; break; // 南アフリカ共和国
          case 'japan':     return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-jpy.svg`; break; // 日本
          case 'swiss':     return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-chf.svg`; break; // スイス
          case 'nz':        return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-nzd.svg`; break; // ニュージーランド

          // 前サイトにて使用（使用はされていないが、突然使用し始めた時用に残しておく）
          case 'br': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-brl.svg`; break; // ブラジル
          case 'hk': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-hkd.svg`; break; // 香港
          case 'in': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-inr.svg`; break; // インド
          case 'kr': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-krw.svg`; break; // 韓国
          case 'mx': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-mxn.svg`; break; // メキシコ
          case 'no': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-nok.svg`; break; // ノルウェー
          case 'ru': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-rub.svg`; break; // ロシア
          case 'se': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-sek.svg`; break; // スウェーデン
          case 'sg': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-sgd.svg`; break; // シンガポール
          case 'pl': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-plz.svg`; break; // ポーランド
          case 'de': return `${domain}/wp-content/themes/trader-fx/assets/flag/flag-usd.svg`; break;
          default:   return ``; break;
        }
      }
    },
  })
}


/* -------------------------------------------------------------------
  columnCarousel
------------------------------------------------------------------- */

if (document.getElementById('columnCarousel')) {
  const columnCarousel = new Vue({
    el: "#columnCarousel",
    components: {
      Slick,
    },
    data() {
      return {
        slickOptions: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px',
          adaptiveHeight: false,
          autoplay: true,
          arrows: false,
          infinite: true,
          dots: false,
          speed: 500,
          // fade: true,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 912,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                // arrows: true,
                // prevArrow: '<div class="column-carousel-prev"></div>',
                // nextArrow: '<div class="column-carousel-next"></div>',
              }
            },
            {
              breakpoint: 599,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
              }
            },
          ]
        },
      }
    },
    mounted() {
    },
    methods: {
      next() {
        this.$refs.slick.next()
      },
      prev() {
        this.$refs.slick.prev()
      },
      reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
          this.$refs.slick.reSlick()
        })
      },
    },
  })
}



/* -------------------------------------------------------------------
  pickupBroker
------------------------------------------------------------------- */

if (document.getElementById('pickupBroker')) {
  const pickupBroker = new Vue({
    el: "#pickupBroker",
    components: {
      Slick,
    },
    data() {
      return {
        slickOptions: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px',
          autoplay: true,
          arrows: false,
          infinite: true,
          dots: false,
          speed: 500,
          // fade: true,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 911,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                // arrows: true,
                // prevArrow: '<div class="column-carousel-prev"></div>',
                // nextArrow: '<div class="column-carousel-next"></div>',
              }
            },
            {
              breakpoint: 599,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
              }
            },
          ]
        },
      }
    },
    mounted() {
    },
    methods: {
      next() {
        this.$refs.slick.next()
      },
      prev() {
        this.$refs.slick.prev()
      },
      reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
          this.$refs.slick.reSlick()
        })
      },
    },
  })
}

